import React, {Component} from 'react';

class Basket extends Component {
    render() {
        return (
            <div>
                Basket
            </div>
        );
    }
}

export default Basket;